import { useContext } from 'react';
import AuthContext from '../../contexts/AuthContext';

/**
 * Returns the in-memory access token from the unified auth context.
 *
 * The chat feature renders inside `AppLayout` under `AuthProvider`; the
 * Socket.IO handshake reads the JWT through this hook. Returns null while
 * unauthenticated so the underlying socket effects stay no-ops.
 */
export function useChatAuthToken(): string | null {
  const auth = useContext(AuthContext);

  if (auth?.isAuthenticated && auth.accessToken) {
    return auth.accessToken;
  }
  return null;
}
